
























































































































































































import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';

import { estadosBrasilItems } from '../../utils/constants';

export default Vue.extend({
  name: 'ThePacientesCadastroExternoEtapa3',
  data() {
    return {
      loading: {
        cep: false,
      },
      valid: false,
      validInternacional: false,
      cepInvalido: false,
      cepHint: '',
      // cepUltimaBusca: '',
      paisBrasil: true,
      formLock: {
        logradouro: true,
        bairro: true,
        cidade: true,
        estado: true,
      },
      form: {
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
      },
      formInternacional: {
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: 'EX',
        pais: '',
      },
      errorMessages: {
        cep: [] as string[],
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        maxLen(maxLength: number) {
          return [
            (v: string) => !!v || 'Campo obrigatório',
            (v: string) => (!!v && v.length <= maxLength) || `Não pode conter mais que ${maxLength} caracteres`,
          ];
        },
      },
      items: {
        estado: estadosBrasilItems,
      },
    };
  },
  computed: {
    formEtapa3(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formEtapa3 as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
    formInternacionalEtapa3(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formInternacionalEtapa3 as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
    axiosInstanceCep() {
      const instance = axios.create();
      instance.defaults.headers.common = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return instance;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'formInternacional.pais': function (val) {
      if (_.lowerCase(val) === 'brasil' || _.lowerCase(val) === 'brazil') {
        this.paisBrasil = true;
        this.$set(this.formInternacional, 'pais', '');
        this.$set(this.form, 'pais', 'Brasil');
      }
    },
  },
  mounted() {
    const formStore = this.$store.getters.pacienteFormExternoEtapa3;
    if (!_.isEmpty(formStore)) {
      this.form = formStore;
    }
    this.formEtapa3.resetValidation();
  },
  methods: {
    async buscaCep() {
      if (this.form.cep.length === 0 || !this.form.cep) {
        this.resetEndereco();
        this.lockEndereco();
        return;
      }
      if (this.form.cep.length !== 9) {
        return;
      }
      const cep: string = this.form.cep.replace('-', '');
      // if (cep === this.cepUltimaBusca) {
      //   return;
      // }
      this.cepHint = '';
      // this.cepUltimaBusca = cep;
      this.loading.cep = true;
      try {
        const response = await this.axiosInstanceCep.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (!response.data.erro) {
          // this.cepUltimaBusca = cep;
          this.form.logradouro = response.data.logradouro;
          this.form.bairro = response.data.bairro;
          this.form.cidade = response.data.localidade;
          this.form.estado = response.data.uf;
        } else {
          this.resetEndereco();
          this.cepHint = 'CEP não encontrado!';
          this.formEtapa3.resetValidation();
        }
        // destrava campos vazios
        this.enderecoLockCheck();
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.cep = false;
      }
    },
    resetEndereco() {
      this.form.logradouro = null;
      this.form.bairro = null;
      this.form.cidade = null;
      this.form.estado = null;
    },
    lockEndereco() {
      this.formLock.logradouro = true;
      this.formLock.bairro = true;
      this.formLock.cidade = true;
      this.formLock.estado = true;
    },
    enderecoLockCheck() {
      if (!this.form.logradouro) this.formLock.logradouro = false;
      if (!this.form.bairro) this.formLock.bairro = false;
      if (!this.form.cidade) this.formLock.cidade = false;
      if (!this.form.estado) this.formLock.estado = false;
    },
    voltar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa3', this.form);
      this.$emit('voltar');
    },
    continuar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa3', this.form);
      if (this.paisBrasil) {
        if (!this.formEtapa3.validate()) {
          return;
        }
        this.$emit('etapaValida', this.form);
      } else {
        if (!this.formInternacionalEtapa3.validate()) {
          return;
        }
        this.$emit('etapaValida', this.formInternacional);
      }
    },
  },
});
